import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import ServiceDetail from '@/pages/ServiceDetail';
import SpecialtyDetail from '@/pages/SpecialtyDetail';
import BookAppointment from '@/pages/BookAppointment';
import Therapists from '@/pages/Therapists';
import Blog from '@/pages/Blog';
import BlogDetail from '@/pages/BlogDetail';
import Insurance from '@/pages/Insurance';

const SiteLayout = ({ routePrefix = '' }) => {
  const route = (publicPath) => routePrefix ? publicPath.replace(/^\//, '') : publicPath;

  return (
    <>
      <Navbar />
      <Routes>
        {routePrefix
          ? <Route index element={<Home />} />
          : <Route path="/" element={<Home />} />}
        <Route path={route('/services/:serviceId')} element={<ServiceDetail />} />
        <Route path={route('/specialty/:specialtyId')} element={<SpecialtyDetail />} />
        <Route path={route('/book-appointment')} element={<BookAppointment />} />
        <Route path={route('/therapists')} element={<Therapists />} />
        <Route path={route('/blog')} element={<Blog />} />
        <Route path={route('/blog/:blogId')} element={<BlogDetail />} />
        <Route path={route('/insurance')} element={<Insurance />} />
      </Routes>
      <Footer />
    </>
  );
};

export default SiteLayout;
